import gql from "graphql-tag";

const DOWNLOADURL_QUERY = gql`
    query DownloadUrl($blobName:String!){
    downloadUrl(blobName:$blobName)
  }
`;
export default DOWNLOADURL_QUERY;